// @ts-expect-error please i just want to build this project
import { HttpStatusCode } from 'axios';
import Common from '../../../Common';

export interface CompanyAdSyncLog {
	added_utc: string
	duration_ms: string
	event_kind: string
	status_code: HttpStatusCode
	status_text: string
	sync_id: string
	adsync_id: id
	pbx_company_id: id
	pbx_user_id: id | null
	changes: null | string
}

const Log = class extends Common {
	status = (companyId: id, adSyncId: id) =>
		this.get(`/company/${companyId}/adsync/${adSyncId}/log/status`)

	browse = (companyId: id, adSyncId: id): CustomResponse<CompanyAdSyncLog[]> =>
		this.get(`/company/${companyId}/adsync/${adSyncId}/log`)
}

export default Log
